import AmiStrings from '../strings.js';

export default function AmiHelpSidebar() {
    var sbName = 'helpList';
    var list = <table />;
    var body = <div>{list}</div>;

    var setTitle;

    var clear = function() {
        while(list.lastChild)
            list.removeChild(list.lastChild);
    };

    return {
        getName: function() { return sbName; },
        isWide: function() { return true; },
        getBody: function() { return body; },
        apply: function(obj) {
            setTitle = obj.setTitle;
        },
        reloadStrings: function() {
            setTitle(AmiStrings.getMenuString('help'));
            clear();

            var rowEven = false;

            AmiStrings.forEachHelpString(function(helpInfo) {
                var row = list.insertRow(0);
                row.className = rowEven ? 'rowEven' : 'rowOdd';

                var title = row.insertCell(0);
                title.style.width = '50%';
                title.textContent = helpInfo.title + ':';

                var example = row.insertCell(1);
                example.appendChild(<i>{helpInfo.format}</i>);

                rowEven = !rowEven;
            });
        },
        clear: clear,
    };
};
